import asyncEntityHandlers from '@anm/helpers/redux/asyncEntityHandlers';
import reduceFactory from '@anm/helpers/redux/reduceFactory';
import { getType } from '@anm/helpers/saga/typesafe-actions';
import { Reducer } from 'redux';

import { appSumoActions } from '.';
import { AppSumoActions, AppSumoState } from './types';

const initialAppSumoState: AppSumoState = {
  data: { isActivated: false },
  upgrade: { error: null, isError: false, isPending: false },
  error: null,
  isError: false,
  isPending: false,
  isRedirectPending: false
};

const appSumoReducer: Reducer<typeof initialAppSumoState, AppSumoActions> = (state = initialAppSumoState, action) => {
  switch (action.type) {
    case getType(appSumoActions.changeRedirectPending): {
      return {
        ...state,
        isRedirectPending: action.payload
      };
    }
    case getType(appSumoActions.checkCouponAsync.request):
    case getType(appSumoActions.activateCouponAsync.request): {
      const coupon = action.payload;

      return {
        ...state,
        data: { ...state.data, coupon, isActivated: false },

        isError: false,
        isPending: true
      };
    }
    case getType(appSumoActions.checkCouponAsync.success): {
      const status = action.payload;

      return {
        ...state,
        data: { ...state.data, status },
        isError: false,
        isPending: false
      };
    }
    case getType(appSumoActions.checkCouponAsync.failure):
    case getType(appSumoActions.activateCouponAsync.failure): {
      const { payload: newError } = action;

      return {
        ...state,
        error: newError,
        isError: true,
        isPending: false
      };
    }

    case getType(appSumoActions.activateCouponAsync.success): {
      return {
        ...state,
        data: { ...state.data, isActivated: true },
        isError: false,
        isPending: false
      };
    }

    default:
      return reduceFactory(initialAppSumoState, {
        ...asyncEntityHandlers<AppSumoState>(appSumoActions.upgradeAsync, 'upgrade')
      })(state, action);
  }
};

export default appSumoReducer;
